const contactForm = document.getElementById('contact-form');
        
function initContactForm() {

	function init() {
		addEventListeners();
	}

	function addEventListeners() {
		contactForm.addEventListener('submit', submit);
	}

	function submit(e) {
		e.preventDefault();

		grecaptcha.ready(function() {
            grecaptcha.execute('6LfZRJseAAAAACOQyAY2r75hi72Vs3CCfJfU1t0Q', {action: 'submit'}).then(function(token) {
				var input = document.createElement('input');
				input.setAttribute('type', 'hidden');
				input.setAttribute('name', 'g-recaptcha-token');
				input.setAttribute('value', token);

				contactForm.appendChild(input);

				contactForm.submit();
            });
        });
	}

	init();
}

if ( contactForm ) {
	initContactForm();
}